import MangaCard from "@/components/feature/MangaCard";
import { featuredManga } from "@/mocks/manga";

export default function FeaturedGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            <span role="img" aria-label="fire">🔥</span> 热门推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500">精选全网最热漫画，大家都在看的精彩内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featuredManga.map((manga) => (
            <MangaCard
              key={manga.id}
              id={manga.id}
              title={manga.title}
              author={manga.author}
              description={manga.description}
              chapters={manga.chapters}
              status={manga.status}
              rating={manga.rating}
              views={manga.views}
              updateTime={manga.updateTime}
              imageUrl={manga.imageUrl}
              imageUrlThumb={manga.imageUrlThumb}
              variant="featured"
            />
          ))}
        </div>
      </div>
    </section>
  );
}